/* Dichter & Denker — kleines Theme-Skript: Ankündigungsleiste, Navigation, Slider */
(function () {
  'use strict';

  /* ---------- Ankündigungsleiste: auf dem Handy rotieren ---------- */
  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.innerWidth > 700) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  }

  /* ---------- Mobile Navigation ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', open);
    });
  }

  /* ---------- Dropdown (Desktop): Hover per CSS, Klick/Touch per JS ---------- */
  function initDropdowns() {
    var dropdowns = document.querySelectorAll('[data-dropdown]');
    Array.prototype.forEach.call(dropdowns, function (dd) {
      var btn = dd.querySelector('[data-dropdown-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = dd.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) {
          dd.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { dd.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      });
    });
  }

  /* ---------- Slider (Bestseller, Denker-Reihe) ---------- */
  function initSliders() {
    var sliders = document.querySelectorAll('[data-slider]');
    Array.prototype.forEach.call(sliders, function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      var count = slider.parentElement.querySelector('[data-slider-count]');
      if (!track) return;
      var items = track.querySelectorAll('[data-slider-item]');
      var total = items.length;

      function itemWidth() {
        if (!items.length) return track.clientWidth;
        var first = items[0];
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function visibleCount() {
        return Math.max(1, Math.round(track.clientWidth / itemWidth()));
      }
      function currentIndex() {
        return Math.min(total, Math.round(track.scrollLeft / itemWidth()) + 1);
      }
      function update() {
        var idx = currentIndex();
        if (count) count.textContent = total ? (idx + ' / ' + total) : '';
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
        if (maxScroll <= 2) { slider.classList.add('is-static'); } else { slider.classList.remove('is-static'); }
      }
      function scrollBy(dir) {
        track.scrollBy({ left: dir * itemWidth() * visibleCount(), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }


  /* ---------- Suche: Leiste unter dem Header ein-/ausblenden ---------- */
  function initSearchToggle() {
    var toggle = document.querySelector('[data-search-toggle]');
    var bar = document.querySelector('[data-searchbar]');
    if (!toggle || !bar) return;
    toggle.addEventListener('click', function () {
      var open = bar.hasAttribute('hidden');
      if (open) {
        bar.removeAttribute('hidden');
        var inp = bar.querySelector('input[type="search"]');
        if (inp) setTimeout(function () { inp.focus(); }, 30);
      } else {
        bar.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Exakte Suche: jedes Wort in Anführungszeichen (siehe templates/search.liquid) ---------- */
  function initExactSearch() {
    var forms = document.querySelectorAll('[data-exact-search]');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function () {
        var inp = form.querySelector('input[name="q"]');
        if (!inp) return;
        var raw = inp.value.trim();
        if (!raw || raw.indexOf('"') !== -1) return;
        var words = raw.split(/\s+/).filter(Boolean);
        inp.value = words.map(function (w) { return '"' + w.replace(/"/g, '') + '"'; }).join(' ');
      });
    });
  }

  /* ---------- Vorschlagssuche (Shopify /search/suggest.json): Kollektionen + Produkte ---------- */
  function initPredictiveSearch() {
    var forms = document.querySelectorAll('[data-psearch]');
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function cleanTitle(t) {
      return t.replace(/^Copy of /, '')
        .replace(/^Unisex-T-Shirt aus Baumwolle -\s*/, '')
        .replace(/^Unisex Heavy Blend™ Rundhals-Sweatshirt -\s*/, '')
        .replace(/^Hoodie Sweatshirt [|\-]\s*/, '');
    }
    function price(p) { return String(p).replace('.', ',') + ' €'; }
    function thumb(url) { if (!url) return ''; return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=96'; }
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('[data-psearch-input]');
      var box = form.querySelector('[data-psearch-results]');
      if (!input || !box) return;
      var timer, controller;
      function close() { box.setAttribute('hidden', ''); box.innerHTML = ''; }
      function render(data, q) {
        var r = (data && data.resources && data.resources.results) || {};
        var cols = r.collections || [], prods = r.products || [];
        var html = '';
        if (cols.length) {
          html += '<div class="hsearch__group"><div class="hsearch__label">Kollektionen</div>' + cols.map(function (c) {
            return '<a class="hsearch__coll" href="' + esc(c.url) + '"><span>' + esc(c.title) + '</span><span aria-hidden="true">→</span></a>';
          }).join('') + '</div>';
        }
        if (prods.length) {
          html += '<div class="hsearch__group"><div class="hsearch__label">Produkte</div>' + prods.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            return '<a class="hsearch__prod" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(thumb(img)) + '" alt="" width="44" height="44" loading="lazy">' : '') +
              '<span class="hsearch__prod-body"><span class="hsearch__prod-title">' + esc(cleanTitle(p.title)) + '</span>' +
              '<span class="hsearch__prod-meta">' + esc(p.type || '') + (p.type ? ' · ' : '') + price(p.price) + '</span></span></a>';
          }).join('') + '</div>';
        }
        if (!html) {
          html = '<div class="hsearch__empty">Keine direkten Treffer – Enter drücken für die volle Suche.</div>';
        }
        html += '<a class="hsearch__all" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">Alle Ergebnisse für „' + esc(q) + '“ →</a>';
        box.innerHTML = html;
        box.removeAttribute('hidden');
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () {
          if (controller) controller.abort();
          controller = new AbortController();
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each' +
            '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,tag,vendor';
          fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (d) { render(d, q); })
            .catch(function () {});
        }, 180);
      });
      input.addEventListener('focus', function () { if (box.innerHTML) box.removeAttribute('hidden'); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  }

  /* ---------- Warenkorb-Zähler nach Ajax-Add aktualisieren (z. B. UpCart) ---------- */
  function initCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    document.addEventListener('cart:updated', refresh);
    window.addEventListener('focus', refresh);
    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { el.textContent = cart.item_count; })
        .catch(function () {});
    }
  }

  function init() {
    initAnnouncement();
    initMobileNav();
    initDropdowns();
    initSliders();
    initCartCount();
    initSearchToggle();
    initExactSearch();
    initPredictiveSearch();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
